'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var explicitNull = {};

exports.__exports = explicitNull;
